import { useEffect, useState } from "react";
import { axiosPrivate } from "../../utils/axios";
import Pagination from "../../components/Table/pagination";
import { ReactComponent as Pdf } from "../../assets/icons/pdf-file-svgrepo-com.svg";
import { ReactComponent as Excel } from "../../assets/icons/excel-svgrepo-com.svg";
import useAuth from "../../hooks/useAuth";
// EXCEL DOWNLOAD //
import * as XLSX from "xlsx"; // Import all exports from 'xlsx'
import { saveAs } from 'file-saver';

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const PAGE_SIZE = 10;

const AgentActivityReport = () => {
    const [activityReport, setActivityReport] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Get User id //
    const user = useAuth();
    const user_id = user.auth.user_details.id;

    const totalPages = Math.ceil(count / PAGE_SIZE);

    const pagination = {
        current_page: page,
        total_pages: totalPages,
        total_records: count,
    };

    const fetch_agent_activity_report = async (pageNumber = 1, isDownload = false) => {
        try {
            setLoading(true);
            setError(null);

            let post_data = {
                "user_id": user_id,
                "search_text": searchText,
                "from": fromDate,
                "to": toDate,
                "download": isDownload
            }

            const response = await axiosPrivate.post(
                `${process.env.REACT_APP_API_URL}/contactcentre/all_agent_activity_report/?page=${pageNumber}`,
                post_data
            );

            if (isDownload) {
                return response.data || [];
            } else {
                setActivityReport(response.data.results || []);
                setCount(response.data.count || 0);
                setPage(pageNumber);
            }

            setCount(response.data.count || 0);
            setPage(pageNumber);
            return response.data || [];

        } catch (err) {
            console.error(err);
            setError("Failed to load data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetch_agent_activity_report(page);
    }, []);

    // Clean Pagination Controller
    const PaginationControl = (type, number = null) => {
        if (type === "page" && number) {
            fetch_agent_activity_report(number);
        }

        if (type === "prev" && page > 1) {
            fetch_agent_activity_report(page - 1);
        }

        if (type === "next" && page < totalPages) {
            fetch_agent_activity_report(page + 1);
        }

        if (type === "last") {
            fetch_agent_activity_report(totalPages);
        }

        if (type === "first") {
            fetch_agent_activity_report(1);
        }
    };

    const [searchText, setSearchText] = useState("")
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };


    const downloadSheet = async (type) => {
        try {
            const data = await fetch_agent_activity_report(1, true);
            if (type === "EXCEL") {
                downloadExcel(data);
            }
            if (type == "PDF") {
                downloadPDF(data);
            }
        } catch (error) {
            console.error("Download error:", error);
        }
    };

    const downloadExcel = (response) => {

        const grouped = {};

        // Group by user
        response.forEach(item => {
            if (!grouped[item.user]) {
                grouped[item.user] = [];
            }
            grouped[item.user].push(item);
        });

        const finalData = [];

        Object.keys(grouped).forEach(user => {

            // Agent name header row
            finalData.push({
                "Agent Name": user,
                "Time": "",
                "Activity": "",
                "Duration": "",
                "Reason": ""
            });

            // Activity rows
            grouped[user].forEach(item => {

                const dateTime = formatDateTime(item.time); // should return merged date-time string

                finalData.push({
                    "Agent Name": "",
                    "Time": dateTime,
                    "Activity": item.activity,
                    "Duration": item.duration_seconds,
                    "Reason": item.reason || ""
                });
            });

            // Spacer row
            finalData.push({
                "Agent Name": "",
                "Time": "",
                "Activity": "",
                "Duration": "",
                "Reason": ""
            });
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(finalData);

        XLSX.utils.book_append_sheet(wb, ws, "Detailed Report");

        XLSX.writeFile(wb, "Agent_Detailed_Report.xlsx");
    };


    const downloadPDF = async (response) => {
        try {
            
            const data = response;
            const doc = new jsPDF("l", "mm", "a4");
            doc.setFontSize(16);
            doc.text("Agent Activity Report", 14, 15);

            const tableRows = data.map((item) => ([
                item.user || "",
                item.activity || "",
                item.time ? new Date(item.time).toLocaleString() : "",
                item.duration_seconds || 0,
                item.reason || ""
            ]));

            autoTable(doc, {
                head: [["Agent Name", "Activity", "Time", "Duration", "Reason"]],
                body: tableRows,
                startY: 22,
                styles: {
                    fontSize: 8,
                    cellPadding: 2
                },
                headStyles: {
                    fillColor: [41, 128, 185]
                },
                theme: "grid",
                didDrawPage: function (data) {
                    const pageCount = doc.internal.getNumberOfPages();
                    doc.setFontSize(10);
                    doc.text(
                        `Page ${pageCount}`,
                        doc.internal.pageSize.width - 30,
                        doc.internal.pageSize.height - 10
                    );
                }
            });

            doc.save("agent_activity_report.pdf");

        } catch (error) {
            console.error("PDF download error:", error);
        }
    };

    const FetchAllAgentActivityReport = () => {
        fetch_agent_activity_report(page);
    }

    return (
        <>
            <div className="bg-white">
                <h1 className="font-bold text-lg pt-8 px-4">Agent Activity Report</h1>
                <div className="flex pt-4">
                    <div className="flex space-x-4">
                        <div className="">
                            <div className="relative">
                                <input
                                    type="text"
                                    id="table-search"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-6 p-2.5  "
                                    placeholder="Search for items"
                                    onChange={(e) => {
                                        setSearchText(e.target.value);
                                    }}
                                />
                            </div>
                        </div>

                        <p>From</p>
                        <div className="relative flex space-x-2">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-500 "
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                                </svg>
                            </div>
                            <input
                                name="start"
                                type="date"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-6 p-2.5  "
                                placeholder="From Date"
                                onChange={(e) => {
                                    setFromDate(e.target.value);
                                }}
                            />
                        </div>
                        <p>To</p>
                        {/* <span className="mx-4 text-gray-500">to</span> */}
                        <div className="relative flex space-x-2">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-500 "
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                                </svg>
                            </div>
                            <input
                                name="end"
                                type="date"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-6 p-2.5  "
                                placeholder="To Date"
                                onChange={(e) => {
                                    setToDate(e.target.value);
                                }}
                            />
                        </div>

                        <div
                            className="flex justify-between space-x-3 bg-red-100 p-2 rounded-2xl cursor-pointer"
                            onClick={() => downloadSheet("PDF")}
                        >
                            <Pdf className="w-5 h-5" />
                            <h1 className="text-red-500">PDF</h1>
                        </div>
                        <div
                            className="flex justify-between space-x-3 bg-green-100 p-2 rounded-2xl cursor-pointer"
                            onClick={() => downloadSheet("EXCEL")}
                        >
                            <Excel className="w-5 h-5" />
                            <h1 className="text-green-500">Excel</h1>
                        </div>

                        <div className="space-x-2">
                            <button
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            onClick={FetchAllAgentActivityReport}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="overflow-hidden">

                                {loading && <p className="text-center p-4">Loading...</p>}
                                {error && <p className="text-center text-red-500">{error}</p>}

                                <table className="min-w-full">
                                    <thead className="border-b">
                                        <tr>
                                            <th className="text-sm font-bold text-gray-400 px-6 py-4 text-left">SlNo</th>
                                            <th className="text-sm font-bold text-gray-400 px-6 py-4 text-left">Agent Name</th>
                                            <th className="text-sm font-bold text-gray-400 px-6 py-4 text-left">Activity</th>
                                            <th className="text-sm font-bold text-gray-400 px-6 py-4 text-left">Time</th>
                                            <th className="text-sm font-bold text-gray-400 px-6 py-4 text-left">Duration</th>
                                            <th className="text-sm font-bold text-gray-400 px-6 py-4 text-left">Reason</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {activityReport.map((agent_report, index) => (
                                            <tr className="border-b" key={`${agent_report.user}-${index}`}>
                                                <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                                                    {(page - 1) * PAGE_SIZE + index + 1}
                                                </td>

                                                <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">{agent_report.user}</td>
                                                <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">{agent_report.activity}</td>
                                                <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                                                    {new Date(agent_report.time).toLocaleString()}
                                                </td>
                                                <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">
                                                    {agent_report.duration_seconds}
                                                </td>
                                                <td className="text-sm text-gray-900 font-bold px-6 py-4 whitespace-nowrap">{agent_report.reason}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div className="p-8">
                                    <Pagination
                                        pagination_data={pagination}
                                        PaginationControl={PaginationControl}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AgentActivityReport;
